import {AccountService} from "../../../account/core/services/AccountService";
export class ReportDetailModalComponent implements ng.IComponentOptions {
  public controller: any = ReportDetailModalController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<",
    close: '&',
    dismiss: '&'
  }
  public template: string = 
    `<div class="modal-header">
      <button type="button" class="close" ng-click="$ctrl.dismiss()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    </div>
    <div class="modal-body">
      <button class="btn btn-default" ng-click="$ctrl.download()">Download</button>
      <table class="table table-hover table-striped">
      <thead>
        <th>Name</th>
        <th>Email</th>
        <th>Type of User</th>
        <th>Organisation</th>
        <th>Register Date</th>
      </thead>
      <tbody>
        <tr ng-repeat="d in $ctrl.data">
          <td>{{d.fullname}}</td>
          <td>{{d.email}}</td>
          <td>{{$ctrl.getType(d.usertype)}}</td>
          <td>{{d.organization.name||d.agency.code||d.ministry.code}}</td>
          <td>{{d.createdOn | date: 'd/M/yyyy'}}</td>
        </tr>
      </tbody>
      </table>
    </div>
    `
}

export class ReportDetailModalController {
  public static $inject: Array<any> = ['AccountService', '$http', '$timeout', '$window']
  public resolve: any;
  public data: Array<any>;
  public types: any;
  constructor(public account: AccountService, private $http: ng.IHttpService, private $timeout: ng.ITimeoutService, private $window: ng.IWindowService) {
    this.$http = $http
    this.$timeout = $timeout
    this.types = {
      'internal': 'Data Champion',
      'external': 'Public Individual',
      'external_org': 'Public Organization'
    }
  }

  public $onInit() {
    this.$timeout(() => {
      this.$http.get(`${BASE}/api/user/list?type=${this.resolve.type}&month=${this.resolve.month}&year=${this.resolve.year}`).then((d:any) => this.data = d.data)
    })
  }

  public getType(type) {
    return this.types[type]
  }

  public download() {
    this.$window.open(`${BASE}/api/user/list?type=${this.resolve.type}&month=${this.resolve.month}&year=${this.resolve.year}&export=true&token=${this.account.token}`, '_blank')
  }
}